import React from 'react'
import styled from 'styled-components'
import { generatePath } from 'react-router'

import { useListRequest, useRequest } from '../hooks/request'
import { PATHS } from '../constants/paths'
import { evaluationList, evaluationDelete } from '../requests/evaluation'
import { getFullName } from '../utils/getFullName'
import { dateToDateTime } from '../utils/dateToDDMMYYYY'
import { DOCUMENT_STATUS } from '../constants/documentStatus'

import { PageTitle } from './common/PageTitle'
import { PageContent } from './layout/layout'
import { List } from './common/List'
import { DeleteButton } from './common/ConfirmButton'
import { DummyButton } from './common/Button'

const HiddenButton = styled(DummyButton)`
  padding: 3px;
  visibility: hidden;
`

const titles = [
  { title: 'trainee' },
  { title: 'internshipName' },
  { title: 'courseName' },
  { title: 'instructorName' },
  { title: 'sendDate' },
  { size: 0, content: <HiddenButton /> },
]
const getRowLink = (item) => generatePath(PATHS.EVALUATION_SHOW, { id: item.id })

const displayItem = (item, props) => [
  { content: item.trainee && getFullName({ user: item.trainee }) },
  { content: item.internship && item.internship.name },
  { content: item.activity },
  { content: item.instructor && getFullName({ user: item.instructor }) },
  { content: dateToDateTime(item.creationDate) },
  {
    content: (
      <DeleteButton
        loading={props.deletingId === item.id}
        titleTrad="confirmDeleteEval"
        onConfirm={() => props.onConfirmDelete({ id: item.id })}
      />
    ),
  },
]

export const EvaluationList = () => {
  const evaluationListRequest = useListRequest({
    start: true,
    startFilter: {
      status: [DOCUMENT_STATUS.PUBLISHED],
    },
    request: evaluationList,
  })

  const evaluationDeleteRequest = useRequest({
    request: evaluationDelete,
    handler: (p) => p.then(evaluationListRequest.fetch),
  })

  return (
    <>
      <PageTitle tradId="evaluations" />
      <PageContent>
        <List
          onConfirmDelete={evaluationDeleteRequest.fetch}
          listRequest={evaluationListRequest}
          columnTitles={titles}
          getRowLink={getRowLink}
          displayItem={displayItem}
          deletingId={evaluationDeleteRequest.state.params?.id}
        />
      </PageContent>
    </>
  )
}
